// extracted by mini-css-extract-plugin
export default {"cls1":"PremiumText-cls1__f0dda2d627900e59ad73","cls2":"PremiumText-cls2__ae56a3ba07abf90f1692 PremiumText-cls1__f0dda2d627900e59ad73"};